import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  FormHelperText
} from '@mui/material';
import { useAuthHeader } from '../Services/Auth/sessionAuth';
import { Crypter } from '../Functions/Security/Crypter';
import axios from 'axios';
import { useEffect, useState } from 'react';
import DataSelect from '../Types/DataSelect';
import ParamsPicklist from '../Types/ParamsPicklist';
import Datas from "../Data/Data.json";
//import { Form } from 'react-router-dom';
import { Form, Input ,InputNumber} from 'antd';


const SelectOptionMUI = (props: {
  disabled?: boolean;
  Size: 'small' | 'medium';
  form: any;
  label: string;
  name: string;
  width?: number;
  widthl?: number;
  Option?: DataSelect[];
  onchange?: (value: any) => void;
  notRequired?: true;
  Parametre?: ParamsPicklist;
  DefaulValue?: any;
  icon?: any;
}) => {
  const notR = props.notRequired ? false : true;
  const authHeader = useAuthHeader();
  const [load, setLoad] = useState(false);
  const [data, setData] = useState<DataSelect[]>(props.Option ? props.Option : []);
  const [touched, setTouched] = useState(false);
  const [selectedValue, setSelectedValue] = useState(props.DefaulValue ?? '');
const [form] = Form.useForm();

  const loadData = async () => {
    setLoad(true);
    const payload = {
      CodeAgence: props.Parametre?.CodeAgence,
      Table: props.Parametre?.Table,
      Colonne1: props.Parametre?.Colonne1,
      Colonne2: props.Parametre?.Colonne2,
      Colagence: props.Parametre?.Colagence,
      Init: props.Parametre?.Init,
      choix: props.Parametre?.Choix,
      colfiltre: props.Parametre?.colfiltre,
      valfiltre: props.Parametre?.valfiltre
    };

    try {
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.AnySearch,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(payload))
        }
      };

      const response = await axios(config);
      const decrypted = JSON.parse(Crypter.decrypt(response.data)).Value;

      if (decrypted.StatutCode === 200 && decrypted.Result?.Table?.length > 0) {
        const loadedData = decrypted.Result.Table.map((row: any) => ({
          value: row[Object.keys(row)[1]],
          label: `${row[Object.keys(row)[1]]}--${row[Object.keys(row)[0]]}`
        }));
        setData(loadedData);
      }

    } catch (error) {
      console.error(error);
    } finally {
      setLoad(false);
    }
  };

  const handleOpen = () => {
    if (data.length === 0) {
      loadData();
    }
  };

  return (
      <Form.Item   preserve={true} name={props.name} style={{ marginBottom: 0 }} rules={[{ required: true, message: 'Champ requis' }]}>
        <FormControl fullWidth size="small">
          <InputLabel shrink id="select-sens-label"
           sx={{ fontWeight: 'bold',fontSize: '25px' }}
            
          >{props.label}</InputLabel>
          <Select
            labelId="select-sens-label"
            label={props.label}
            disabled={props.disabled}
           value={props.form.getFieldValue(props.name) || ""}
         onChange={(e) => {
             const newValue = e.target.value;
             props.form.setFieldValue(props.name, newValue); // ✅ Lier au form
              props.onchange?.(newValue);
           }}
           // onChange={(e) => props.form?.setFieldsValue({ Sence: e.target.value })}
            displayEmpty
            renderValue={(selected) => {
              if (!selected) return <em></em>;
              const opt = props.Option?.find((o) => o.value === selected);
              return opt ? opt.label : selected;
            }}
             variant="outlined"
      sx={{ width: '100%', borderRadius:1,
        '& .MuiInputLabel-root': {
      fontWeight: 'bold',
      fontSize: '18px',
    }
       }}
          >
            <MenuItem value="">
              <em></em>
            </MenuItem>
            {props.Option?.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Form.Item> 
        
  //      <Form.Item name="Sence" style={{ marginBottom: 0 }} rules={[{ required: true, message: 'Champ requis' }]}>
  //       <FormControl
  //     fullWidth
  //     size={props.Size}
  //     required={notR}
  //     disabled={props.disabled}
     
  //   //   style={{ marginTop: 16, marginBottom: 8 }}
  //   >
  //     <InputLabel>{props.label}</InputLabel>

  //     <Select
  //        name={props.name}
  //        label={props.label}
  //        value={selectedValue}
  //        onChange={(e) => {
  //           const newValue = e.target.value;
  //           setSelectedValue(newValue);
  //           props.onchange?.(newValue);
  //           }}
  //       onOpen={handleOpen}
  //       IconComponent={props.icon}
  //       displayEmpty
  //       renderValue={(selected) => {
  //   if (!selected) return <em></em>;
  //   const selectedOption = data.find(opt => opt.value === selected);
  //   return selectedOption ? selectedOption.label : selected;
  // }}
  //     >
  //       {load ? (
  //         <MenuItem disabled>
  //           <CircularProgress size={20} />
  //         </MenuItem>
  //       ) : (
  //         data.map((option) => (
  //           <MenuItem key={option.value} value={option.value}>
  //             {option.label}
  //           </MenuItem>
  //         ))
  //       )}
  //     </Select>

  //     {/* {notR && !props.DefaulValue && touched && (
  //       <FormHelperText>Ce champ est requis.</FormHelperText>
  //     )} */}
  //   </FormControl>
  //     </Form.Item>
    
  );
};

export default SelectOptionMUI;
